import { render, staticRenderFns } from "./Square.vue?vue&type=template&id=a5454004&scoped=true&"
import script from "./Square.vue?vue&type=script&lang=js&"
export * from "./Square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5454004",
  null
  
)

export default component.exports